import * as yup from 'yup';
import { updateJadwaTransferFormFields } from '../../fields/formFields/jadwa';

export const updateJadwaTransferFormSchema = yup.object({
  [updateJadwaTransferFormFields.amount]: yup.number().positive().required('Amount is required'),
  [updateJadwaTransferFormFields.status]: yup.string().required('Status is required').trim(),
});
